import { render, staticRenderFns } from "./vue-clown-component.vue?vue&type=template&id=2eabb8b4&shadow"
import script from "./vue-clown-component.vue?vue&type=script&lang=js&shadow"
export * from "./vue-clown-component.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./vue-clown-component.vue?vue&type=style&index=0&id=2eabb8b4&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports